:host {
  display: block;

  --_omk-select-option-label-text-colour: var(
    --omk-select-option-label-text-colour,
    var(--omk-colour-text-active-hover)
  );
  --_omk-select-option-disabled-label-text-colour: var(
    --omk-select-option-disabled-label-text-colour,
    var(--omk-colour-text-disabled-resting)
  );
  --_omk-select-option-label-font-family: var(
    --omk-select-option-label-font-family,
    var(--omk-font-body-normal-font-family)
  );
  --_omk-select-option-label-font-size: var(--omk-select-option-label-font-size, var(--omk-font-body-normal-font-size));
  --_omk-select-option-label-line-height: var(
    --omk-select-option-label-line-height,
    var(--omk-font-body-normal-line-height)
  );
  --_omk-select-option-label-font-weight: var(
    --omk-select-option-label-font-weight,
    var(--omk-font-body-normal-font-weight)
  );
  --_omk-select-option-icon-colour: var(
    --omk-select-option-icon-colour,
    var(--omk-colour-icon-primary-resting)
  );
  --_omk-select-option-disabled-leading-icon-colour: var(
    --omk-select-option-disabled-leading-icon-colour,
    var(--omk-colour-icon-disabled-disabled)
  );
  --_omk-select-option-padding-x: var(--omk-select-option-padding-x, var(--omk-dimension-spacing-xsmall));
  --_omk-select-option-padding-y: var(--omk-select-option-padding-y, var(--omk-dimension-spacing-xxsmall));
  --_omk-select-option-min-height: var(--omk-select-option-min-height, var(--omk-dimension-units-14));
  --_omk-select-option-selected-background-colour: var(
    --omk-select-option-selected-background-colour,
    var(--omk-colour-container-active-primary-resting)
  );
  --_omk-select-option-hovered-background-colour: var(
    --omk-select-option-hovered-background-colour,
    var(--omk-colour-container-active-primary-hover)
  );
  --_omk-select-option-pressed-background-colour: var(
    --omk-select-option-pressed-background-colour,
    var(--omk-colour-container-active-primary-press)
  );

  --_omk-select-option-focus-ring-shape: var(--omk-select-option-focus-ring-shape, 0);
  --_omk-select-option-focus-ring-width: var(--omk-select-option-focus-ring-width, 2px);
  --_omk-select-option-focus-ring-colour: var(
    --omk-select-option-focus-ring-colour,
    var(--omk-colour-border-primary-focus)
  );

  --md-menu-item-label-text-color: var(--_omk-select-option-label-text-colour);
  --md-menu-item-selected-label-text-color: var(--_omk-select-option-label-text-colour);
  --md-menu-item-hover-label-text-color: var(--_omk-select-option-label-text-colour);
  --md-menu-item-label-text-font: var(--_omk-select-option-label-font-family);
  --md-menu-item-label-text-size: var(--_omk-select-option-label-font-size);
  --md-menu-item-label-text-line-height: var(--_omk-select-option-label-line-height);
  --md-menu-item-label-text-weight: var(--_omk-select-option-label-font-weight);
  --md-menu-item-leading-icon-color: var(--_omk-select-option-icon-colour);
  --md-menu-item-trailing-icon-color: var(--_omk-select-option-icon-colour);
  --md-menu-item-one-line-container-height: var(--_omk-select-option-min-height);
  --md-menu-item-top-space: var(--_omk-select-option-padding-y);
  --md-menu-item-bottom-space: var(--_omk-select-option-padding-y);
  --md-menu-item-leading-space: var(--_omk-select-option-padding-x);
  --md-menu-item-trailing-space: var(--_omk-select-option-padding-x);

  --md-menu-item-selected-container-color: var(--_omk-select-option-selected-background-colour);
  /* The state layer renders over the text, so we're going our own way for hover and pressed state and sacrificing ripple effects. */
  --md-menu-item-pressed-state-layer-opacity: 0;
  --md-menu-item-hover-state-layer-opacity: 0;
  --md-menu-item-disabled-opacity: 1;
  --md-focus-ring-shape-start-start: var(--_omk-select-option-focus-ring-shape);
  --md-focus-ring-shape-start-end: var(--_omk-select-option-focus-ring-shape);
  --md-focus-ring-shape-end-start: var(--_omk-select-option-focus-ring-shape);
  --md-focus-ring-shape-end-end: var(--_omk-select-option-focus-ring-shape);
  --md-focus-ring-width: var(--_omk-select-option-focus-ring-width);
  --md-focus-ring-color: var(--_omk-select-option-focus-ring-colour);
}

:host(:hover) {
  --md-menu-item-container-color: var(--_omk-select-option-hovered-background-colour);
}

:host(:active) {
  --md-menu-item-container-color: var(--_omk-select-option-pressed-background-colour);
}

:host([disabled]) {
  --md-menu-item-label-text-color: var(--_omk-select-option-disabled-label-text-colour);
  --md-menu-item-leading-icon-color: var(--_omk-select-option-disabled-leading-icon-colour);
  --md-menu-item-trailing-icon-color: var(--_omk-select-option-disabled-leading-icon-colour);
}
